export const FETCH_PROJECTTOPTENENTRIES_REQUEST = 'FETCH_PROJECTTOPTENENTRIES_REQUEST';
export const FETCH_PROJECTTOPTENENTRIES_SUCCESS = 'FETCH_PROJECTTOPTENENTRIES_SUCCESS';
export const FETCH_PROJECTTOPTENENTRIES_FAILURE = 'FETCH_PROJECTTOPTENENTRIES_FAILURE';
export const CREATE_PROJECTTOPTENENTRY_REQUEST = 'CREATE_PROJECTTOPTENENTRY_REQUEST';
export const CREATE_PROJECTTOPTENENTRY_SUCCESS = 'CREATE_PROJECTTOPTENENTRY_SUCCESS';
export const CREATE_PROJECTTOPTENENTRY_FAILURE = 'CREATE_PROJECTTOPTENENTRY_FAILURE';
export const UPDATE_PROJECTTOPTENENTRY_REQUEST = 'UPDATE_PROJECTTOPTENENTRY_REQUEST';
export const UPDATE_PROJECTTOPTENENTRY_SUCCESS = 'UPDATE_PROJECTTOPTENENTRY_SUCCESS';
export const UPDATE_PROJECTTOPTENENTRY_FAILURE = 'UPDATE_PROJECTTOPTENENTRY_FAILURE';